import axios from "axios";
import {
  CHECK_EXCHANGE_IP_ERROR,
  CHECK_EXCHANGE_IP_REQUEST,
  CHECK_EXCHANGE_IP_SUCCESS,
  CLOSE_CONNECTION_FORM,
  EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_ERROR,
  EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_REQUEST,
  EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_SUCCESS,
  EXCHANGE_TRADE_HISTORY_ERROR,
  EXCHANGE_TRADE_HISTORY_REQUEST,
  EXCHANGE_TRADE_HISTORY_SUCCESS,
  GET_ASSETS_ERROR,
  GET_ASSETS_REQUEST,
  GET_ASSETS_SUCCESS,
  GET_COIN_FROM_EXCHANGE_ERROR,
  GET_COIN_FROM_EXCHANGE_REQUEST,
  GET_COIN_FROM_EXCHANGE_SUCCESS,
  GET_CONNECTION_INFO_ERROR,
  GET_CONNECTION_INFO_REQUEST,
  GET_CONNECTION_INFO_SUCCESS,
  GET_EXCHANGE_BALANCE_CHART_ERROR,
  GET_EXCHANGE_BALANCE_CHART_REQUEST,
  GET_EXCHANGE_BALANCE_CHART_SUCCESS,
  GET_EXCHANGE_FROM_COIN_ERROR,
  GET_EXCHANGE_FROM_COIN_REQUEST,
  GET_EXCHANGE_PORTFOLIO_ERROR,
  GET_EXCHANGE_PORTFOLIO_REQUEST,
  GET_EXCHANGE_PORTFOLIO_SUCCESS,
  GET_EXCHANGE_PRICE_ERROR,
  GET_EXCHANGE_PRICE_REQUEST,
  GET_EXCHANGE_PRICE_SUCCESS,
  GET_EXCHANGES_INFO_ERROR,
  GET_EXCHANGES_INFO_REQUEST,
  GET_EXCHANGES_INFO_SUCCESS,
  GET_INTEGRATED_EXCHANGES_ERROR,
  GET_INTEGRATED_EXCHANGES_REQUEST,
  GET_INTEGRATED_EXCHANGES_SUCCESS,
  GET_TRUSTED_IPS_ERROR,
  GET_TRUSTED_IPS_REQUEST,
  GET_TRUSTED_IPS_SUCCESS,
  INTEGRATE_EXCHANGE_ERROR,
  INTEGRATE_EXCHANGE_REQUEST,
  INTEGRATE_EXCHANGE_SUCCESS,
  LINK_WITH_EXCHANGE_ERROR,
  LINK_WITH_EXCHANGE_REQUEST,
  LINK_WITH_EXCHANGE_SUCCESS,
  OPEN_CONNECTION_FORM,
  ORDER_TRADE_ERROR,
  ORDER_TRADE_REQUEST,
  ORDER_TRADE_SUCCESS,
  SET_EXCHANGE_FOR_CONNECTION,
  SET_PREVIOUS_PATH,
  SET_SELECTED_PORTFOLIO_EXCHANGE,
  UNLINK_FROM_EXCHANGE_ERROR,
  UNLINK_FROM_EXCHANGE_REQUEST,
  UNLINK_FROM_EXCHANGE_SUCCESS,
  UPDATE_EXCHANGE_HISTORY_SUCCESS,
  UPDATE_EXCHANGE_PORTFOLIO_DATA,
} from "./consts";
import { errorHandler, reorderArray } from "../../utility/helper";
import alert from "../../components/alerts/Alert";
import { getProfileData, updateProfileAttribute } from "../profile/actions";
import {
  setVirtualPortfolio,
  updateAIPortfolioData,
} from "../trading-assistant/actions";
import { formatAssetNameForTrade } from "../../utility/tradeHelper";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";
import { openSideMenu } from "../ui/uiSlice";

const baseUrl =
  "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";

export const getExchangesInfo =
  (retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_EXCHANGES_INFO_REQUEST });

    const data = { mode: "get_exchanges_info_and_connections" };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        dispatch({ type: GET_EXCHANGES_INFO_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getExchangesInfo(retryCount + 1),
          GET_EXCHANGES_INFO_ERROR,
          "user",
          "email",
          formatTelegramLog(
            "get_exchanges_info_and_connections",
            data,
            baseUrl,
          ),
          0,
          currentPath,
        );
      });
  };

export const integrateWithExchange =
  (
    user,
    email,
    apiKey,
    secretKey,
    exchange_id,
    passphrase,
    restricted_ip,
    name,
    showAlert = true,
    getPortfolio = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: INTEGRATE_EXCHANGE_REQUEST });

    const data = {
      mode: "integrate_with_exchange",
      user,
      email,
      apiKey,
      secretKey,
      exchange_id,
      passphrase,
      restricted_ip,
    };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        dispatch({ type: INTEGRATE_EXCHANGE_SUCCESS, payload: res.data });
        // You have successfully integrated with

        if (showAlert) {
          alert(null, res.data?.MESSAGE, "success", {
            cancel: "Ok",
          });
        }
        if (getPortfolio) {
          dispatch(getExchangePortfolio(user, email, exchange_id));
        }
        // dispatch(getIntegratedExchanges(user, email));
        dispatch(updateIntegratedData(exchange_id, name));
        // notify(res.data.message, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            integrateWithExchange(
              user,
              email,
              apiKey,
              secretKey,
              exchange_id,
              passphrase,
              restricted_ip,
              name,
              showAlert,
              retryCount + 1,
            ),
          INTEGRATE_EXCHANGE_ERROR,
          user,
          email,
          formatTelegramLog("integrate_with_exchange", data, baseUrl),
          0,
          currentPath,
        );
      });
  };

export const updateIntegratedData = (exchangeId, name) => (dispatch) => {
  dispatch({ type: "update-integrated-data", payload: { exchangeId, name } });
};

export const clearIntegrationProcessData = () => (dispatch) => {
  dispatch({ type: "clear-integration-process-data" });
};

export const getIntegratedExchanges =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_INTEGRATED_EXCHANGES_REQUEST });

    const data = { mode: "get_integrated_exchange", user, email };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        // console.log(res);
        dispatch({
          type: GET_INTEGRATED_EXCHANGES_SUCCESS,
          payload: reorderArray(res.data),
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getIntegratedExchanges(user, email, retryCount + 1),
          GET_INTEGRATED_EXCHANGES_ERROR,
          user,
          email,
          formatTelegramLog("get_integrated_exchange", data, baseUrl),
          0,
          currentPath,
        );
      });
  };

export const checkExchangeStatus =
  (
    user,
    email,
    exchange_id,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: CHECK_EXCHANGE_IP_REQUEST });

    const data = {
      mode: "get_integrated_exchange",
      user,
      email,
      exchange_id,
    };
    const url =
      "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        // console.log(res);
        dispatch({ type: CHECK_EXCHANGE_IP_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => checkExchangeStatus(user, email, exchange_id, retryCount + 1),
          CHECK_EXCHANGE_IP_ERROR,
          user,
          email,
          formatTelegramLog("get_integrated_exchange", data, url),
          0,
          currentPath,
        );
      });
  };

export const resetExchangeStatusData = () => (dispatch) => {
  dispatch({ type: "reset-exchange-status" });
};

export const getExchangeTradeHistory =
  (
    user,
    email,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: EXCHANGE_TRADE_HISTORY_REQUEST });

    const data = {
      mode: "get_exchange_trade_history",
      user,
      email,
      exchange_id,
    };

    await axios
      .post(baseUrl, data, { signal })
      .then((res) => {
        dispatch({ type: EXCHANGE_TRADE_HISTORY_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          dispatch({ type: "exchange_trade_history_cancelled" });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              getExchangeTradeHistory(
                user,
                email,
                exchange_id,
                signal,
                retryCount + 1,
              ),
            EXCHANGE_TRADE_HISTORY_ERROR,
            user,
            email,
            formatTelegramLog("get_exchange_trade_history", data, baseUrl),
            0,
            currentPath,
          );
        }
      });
  };

export const getExchangeComprehensiveTradeHistory =
  (
    user,
    email,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_REQUEST });

    const data = {
      mode: "get_exchange_trade_history_comphrensive",
      user,
      email,
      exchange_id,
    };

    try {
      // بررسی زودهنگام
      if (signal?.aborted) {
        dispatch({ type: "exchange_comprehensive_trade_history_cancelled" });
        return;
      }

      const res = await axios.post(baseUrl, data, { signal });

      dispatch({
        type: EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        dispatch({ type: "exchange_comprehensive_trade_history_cancelled" });
      } else {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getExchangeComprehensiveTradeHistory(
              user,
              email,
              exchange_id,
              signal,
              retryCount + 1,
            ),
          EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_ERROR,
          user,
          email,
          formatTelegramLog(
            "get_exchange_trade_history_comphrensive",
            data,
            baseUrl,
          ),
          0,
          currentPath,
        );
      }
    }
  };

export const updateExchangeHistory =
  (
    user,
    email,
    exchange_id,
    last_trade_history_date,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_REQUEST });

    const data = {
      mode: "get_exchange_trade_history_comphrensive",
      user,
      email,
      exchange_id,
      last_trade_history_date,
    };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        console.log(res, res?.data);
        if (res.data?.length === 0) {
          alert("", "No more data available.", "info", {
            cancel: "Close",
          });
        }
        dispatch({ type: UPDATE_EXCHANGE_HISTORY_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            updateExchangeHistory(
              user,
              email,
              exchange_id,
              last_trade_history_date,
              retryCount + 1,
            ),
          EXCHANGE_COMPREHENSIVE_TRADE_HISTORY_ERROR,
          user,
          email,
          formatTelegramLog("get_exchange_trade_history", data, baseUrl),
          0,
          currentPath,
        );
      });
  };

export const orderTrade =
  (
    user,
    email,
    exchange_id,
    asset,
    trade_type,
    amount,
    trigger_price,
    freeze,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: ORDER_TRADE_REQUEST });

    const data = {
      mode: "order_trade",
      user,
      email,
      exchange_id,
      asset: formatAssetNameForTrade(asset, exchange_id),
      trade_type,
      amount: `${amount}`,
      trigger_price: `${trigger_price}`,
      currency: "USDT",
      freeze_limit_order: freeze ? "True" : "False",
    };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: ORDER_TRADE_SUCCESS, payload: res.data });
          // dispatch(getExchangePortfolio(user, email, exchange_id));
          dispatch(setSelectedPortfolioExchange(exchange_id, user, email));
        } else {
          dispatch({ type: ORDER_TRADE_ERROR, payload: res?.data || {} });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 421) {
          dispatch({ type: ORDER_TRADE_ERROR, payload: err?.response?.data || {} });
          return;
        }
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            orderTrade(
              user,
              email,
              exchange_id,
              asset,
              trade_type,
              amount,
              trigger_price,
              freeze,
              retryCount + 1,
            ),
          ORDER_TRADE_ERROR,
          user,
          email,
          formatTelegramLog("order_trade", data, baseUrl),
          0,
          currentPath,
        );
      });
  };

export const getExchangePrice =
  (
    user,
    email,
    exchange_id,
    assets,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_EXCHANGE_PRICE_REQUEST });

    const data = {
      mode: "get_prices",
      user,
      email,
      exchange_id,
      assets,
    };

    await axios
      .post(baseUrl, data)
      .then((res) => {
        dispatch({ type: GET_EXCHANGE_PRICE_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getExchangePrice(user, email, exchange_id, assets, retryCount + 1),
          GET_EXCHANGE_PRICE_ERROR,
          user,
          email,
          formatTelegramLog("get_prices", data, baseUrl),
          0,
          currentPath,
        );
      });
  };

const PORTFOLIO_CACHE_KEY = "cc_exchange_portfolio_v1";
const PORTFOLIO_CACHE_MS = 30 * 60 * 1000;

function portfolioCacheId(user, email, exchangeId) {
  return `${user}|${email}|${exchangeId}`;
}

function readPortfolioCache(user, email, exchangeId) {
  try {
    const all = JSON.parse(sessionStorage.getItem(PORTFOLIO_CACHE_KEY) || "{}");
    const row = all[portfolioCacheId(user, email, exchangeId)];
    if (!row || Date.now() - row.savedAt > PORTFOLIO_CACHE_MS) return null;
    return row.data;
  } catch (e) {
    return null;
  }
}

function writePortfolioCache(user, email, exchangeId, data) {
  try {
    const all = JSON.parse(sessionStorage.getItem(PORTFOLIO_CACHE_KEY) || "{}");
    all[portfolioCacheId(user, email, exchangeId)] = {
      savedAt: Date.now(),
      data,
    };
    sessionStorage.setItem(PORTFOLIO_CACHE_KEY, JSON.stringify(all));
  } catch (e) {}
}

export const getExchangePortfolio =
  (
    user,
    email,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
    refresh = false,
  ) =>
  async (dispatch) => {
    if (!refresh && retryCount === 0) {
      const cached = readPortfolioCache(user, email, exchange_id);
      if (cached) {
        dispatch({
          type: GET_EXCHANGE_PORTFOLIO_SUCCESS,
          payload: cached,
        });
        return;
      }
    }

    dispatch({ type: GET_EXCHANGE_PORTFOLIO_REQUEST });

    const data = {
      mode: "get_portfolio",
      user,
      email,
      exchange_id,
      use_more_caching: refresh ? "False" : "True",
    };
    if (refresh) data.refresh = "True";

    await axios
      .post(baseUrl, data, { signal })
      .then((res) => {
        writePortfolioCache(user, email, exchange_id, res.data);
        dispatch({
          type: GET_EXCHANGE_PORTFOLIO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          dispatch({ type: "GET_EXCHANGE_PORTFOLIO_cancelled" });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              getExchangePortfolio(
                user,
                email,
                exchange_id,
                signal,
                retryCount + 1,
                currentPath,
                refresh,
              ),
            GET_EXCHANGE_PORTFOLIO_ERROR,
            user,
            email,
            formatTelegramLog("get_portfolio", data, baseUrl),
            0,
            currentPath,
          );
        }
      });
  };

export const updateExchangePortfolio = (newPortfolio) => {
  return { type: UPDATE_EXCHANGE_PORTFOLIO_DATA, payload: newPortfolio };
};

export const getAssetList =
  (user, email, exchange_id, retryCount = 0) =>
  async (dispatch) => {
    dispatch({ type: GET_ASSETS_REQUEST });

    await axios
      .post(baseUrl, {
        mode: "get_asset_list",
        user,
        email,
        exchange_id,
      })
      .then((res) => {
        dispatch({ type: GET_ASSETS_SUCCESS, payload: res.data.asset_list });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getAssetList(user, email, exchange_id, retryCount + 1),
          GET_ASSETS_ERROR,
          user,
          email,
          "get_asset_list",
        );
        // const { STATUS_CODE, MESSAGE } = err?.response.data;
        // dispatch({ type: GET_ASSETS_ERROR, payload: MESSAGE });
        // errorHandler(STATUS_CODE, MESSAGE);
      });
  };

export const getExchangeConnectionInfo = (exchange_id) => async (dispatch) => {
  dispatch({ type: GET_CONNECTION_INFO_REQUEST });
  await axios
    .post(baseUrl, {
      mode: "get_exchange_connection_info",
      exchange_id,
    })
    .then((res) => {
      dispatch({ type: GET_CONNECTION_INFO_SUCCESS, payload: res.data });
    })
    .catch((err) => {
      const { STATUS_CODE, MESSAGE } = err?.response.data;
      dispatch({ type: GET_CONNECTION_INFO_ERROR, payload: MESSAGE });
      errorHandler(STATUS_CODE, MESSAGE);
    });
};

export const setPreviousPath = (path) => {
  return { type: SET_PREVIOUS_PATH, payload: path };
};

let abortController = null;

export const setSelectedPortfolioExchange =
  (exchange, user, email) => (dispatch) => {
    if (abortController) {
      abortController.abort();
    }

    dispatch({ type: SET_SELECTED_PORTFOLIO_EXCHANGE, payload: exchange });

    abortController = new AbortController();
    const { signal } = abortController;

    dispatch(getExchangePortfolio(user, email, exchange, signal));

    dispatch(
      getExchangeComprehensiveTradeHistory(user, email, exchange, signal),
    );

    dispatch(getExchangeTradeHistory(user, email, exchange, signal));

    dispatch(getExchangeBalanceChart(user, email, exchange, signal));
  };

export const setExchangeForConnection = (exchange) => {
  return { type: SET_EXCHANGE_FOR_CONNECTION, payload: exchange };
};

export const linkWithExchange =
  (email, user, exchange_id, portfolio_type, retryCount = 0) =>
  async (dispatch) => {
    dispatch({ type: LINK_WITH_EXCHANGE_REQUEST });

    await axios
      .post(
        "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        {
          platform_mode: "trade_assistant",
          request_type: "link_exchange_to_portfolio",
          email,
          user,
          exchange_id,
          portfolio_type,
        },
      )
      .then((res) => {
        const { MESSAGE, STATUS_CODE } = res?.data;
        dispatch({
          type: LINK_WITH_EXCHANGE_SUCCESS,
          payload: MESSAGE,
        });

        const profileAttribute =
          portfolio_type === "primary"
            ? "portfolio1_linked_exchange"
            : "portfolio2_linked_exchange";

        dispatch(updateAIPortfolioData(res?.data));
        dispatch(setVirtualPortfolio(portfolio_type));
        dispatch(updateProfileAttribute(profileAttribute, exchange_id));
        dispatch(getProfileData(email, user));

        alert(null, res?.data?.MESSAGE, "success", {
          cancel: "Ok",
        });
      })
      .catch((err) => {
        if (err?.code === "ERR_NETWORK") {
          dispatch({
            type: LINK_WITH_EXCHANGE_SUCCESS,
            payload: "The portfolio is linked with exchange successfuly",
          });
          const profileAttribute =
            portfolio_type === "primary"
              ? "portfolio1_linked_exchange"
              : "portfolio2_linked_exchange";

          dispatch(
            updateAIPortfolioData({
              STATUS_CODE: 200,
              MESSAGE: "The portfolio is linked with exchange successfuly",
            }),
          );
          dispatch(setVirtualPortfolio(portfolio_type));
          dispatch(updateProfileAttribute(profileAttribute, exchange_id));
          dispatch(getProfileData(email, user));
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              linkWithExchange(
                email,
                user,
                exchange_id,
                portfolio_type,
                retryCount + 1,
              ),
            LINK_WITH_EXCHANGE_ERROR,
            user,
            email,
            "link_exchange_to_portfolio",
          );
          // const { STATUS_CODE, MESSAGE } = err?.response.data;
          // dispatch({ type: LINK_WITH_EXCHANGE_ERROR, payload: MESSAGE });
          // errorHandler(STATUS_CODE, MESSAGE, true);
        }
      });
  };

export const unlinkFromExchange =
  (email, user, portfolio_type, retryCount = 0) =>
  async (dispatch) => {
    dispatch({ type: UNLINK_FROM_EXCHANGE_REQUEST });

    await axios
      .post(
        "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        {
          platform_mode: "trade_assistant",
          request_type: "unlink_portfolio_from_exchanges",
          email,
          user,
          portfolio_type,
        },
      )
      .then((res) => {
        dispatch({
          type: UNLINK_FROM_EXCHANGE_SUCCESS,
          payload: res?.data?.MESSAGE,
        });

        const profileAttribute =
          portfolio_type === "primary"
            ? "portfolio1_linked_exchange"
            : "portfolio2_linked_exchange";

        dispatch(setVirtualPortfolio(portfolio_type));
        dispatch(updateProfileAttribute(profileAttribute, "None"));
        dispatch(getProfileData(email, user));
        // dispatch(getPortfolioData(email, user, portfolio_type));

        alert(null, res?.data?.MESSAGE, "success", {
          cancel: "Ok",
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => unlinkFromExchange(email, user, portfolio_type, retryCount + 1),
          UNLINK_FROM_EXCHANGE_ERROR,
          user,
          email,
          "unlink_portfolio_from_exchanges",
        );
        // console.log(err);
        // const { STATUS_CODE, MESSAGE } = err?.response.data;
        // dispatch({ type: UNLINK_FROM_EXCHANGE_ERROR, payload: MESSAGE });
        // errorHandler(STATUS_CODE, MESSAGE);
      });
  };

export const getTrustedIps =
  (retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_TRUSTED_IPS_REQUEST });

    const url =
      "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      mode: "get_restricted_ip",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: GET_TRUSTED_IPS_SUCCESS,
          payload: res?.data?.trusted_ips,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getTrustedIps(retryCount + 1),
          GET_TRUSTED_IPS_ERROR,
          "user",
          "email",
          formatTelegramLog("get_restricted_ip", data, url),
          0,
          currentPath,
        );
      });
  };

export const getExchangeBalanceChart =
  (
    user,
    email,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_EXCHANGE_BALANCE_CHART_REQUEST });

    const url =
      "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      mode: "get_balance_chart",
      user,
      email,
      exchange_id,
    };

    await axios
      .post(url, data, { signal })
      .then((res) => {
        console.log(res);
        dispatch({
          type: GET_EXCHANGE_BALANCE_CHART_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          dispatch({ type: "get-exchange-balance-chart-cancelled" });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              getExchangeBalanceChart(
                user,
                email,
                exchange_id,
                signal,
                retryCount + 1,
              ),
            GET_EXCHANGE_BALANCE_CHART_ERROR,
            user,
            email,
            formatTelegramLog("exchange/get_balance_chart", data, url),
            0,
            currentPath,
          );
        }
      });
  };

export const getAvailableCoins =
  (
    data,
    include_limits = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_COIN_FROM_EXCHANGE_REQUEST, payload: data });

    const url =
      "https://sflawrtfnk.execute-api.ap-southeast-2.amazonaws.com/dev/info";

    const exchange =
      data === "swyftx" || data === "cryptocrispy" ? "binance" : data;

    const payloadData = {
      type: "exchange",
      data: exchange,
      include_limits: "False",
    };

    if (include_limits) {
      payloadData.include_limits = "True";
    }

    await axios
      .post(url, payloadData)
      .then((res) => {
        console.log(res);
        dispatch({
          type: GET_COIN_FROM_EXCHANGE_SUCCESS,
          payload: {
            data: res?.data?.coins,
            exchange: data,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_COIN_FROM_EXCHANGE_ERROR, payload: data });
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getAvailableCoins(data, retryCount + 1),
          GET_COIN_FROM_EXCHANGE_ERROR,
          "user",
          "email",
          formatTelegramLog("get_asset_coins_by_exchange", payloadData, url),
          0,
          currentPath,
        );
      });
  };

export const getAvailableExchanges =
  (
    data,
    include_limits = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_EXCHANGE_FROM_COIN_REQUEST, coin: data });

    const url =
      "https://sflawrtfnk.execute-api.ap-southeast-2.amazonaws.com/dev/info";

    const payloadData = { type: "coin", data, include_limits: "False" };

    if (include_limits) {
      payloadData.include_limits = "True";
    }

    await axios
      .post(url, payloadData)
      .then((res) => {
        console.log(res);
        // dispatch({ type: GET_COIN_FROM_EXCHANGE_SUCCESS, payload: res.data.asset_list });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getAvailableExchanges(data, retryCount + 1),
          GET_EXCHANGE_FROM_COIN_ERROR,
          "user",
          "email",
          formatTelegramLog("get_asset_coins_by_exchange", payloadData, url),
          0,
          currentPath,
        );
      });
  };

export const openExchangeConnectionSettings =
  (targetExchange = "") =>
  (dispatch) => {
    dispatch(
      openSideMenu(
        "exchange-connection-settings",
        "exchange-connection-settings",
      ),
    );

    dispatch({ type: OPEN_CONNECTION_FORM, payload: targetExchange });
  };

export const closeExchangeConnectionSettings = () => (dispatch) => {
  dispatch({ type: CLOSE_CONNECTION_FORM });
};

export const getAllExchangesWithTheirCoins =
  (signal = null, retryCount = 0, currentPath = window.location.href) =>
  async (dispatch) => {
    dispatch({ type: "get-all-exchanges-with-coins-request" });

    const data = {
      type: "all_exchanges_with_coins",
    };

    const url = "https://sflawrtfnk.execute-api.ap-southeast-2.amazonaws.com/dev/info"

    await axios
      .post(
        url,
        data,
        { signal },
      )
      .then((res) => {
        // console.log(res);
        dispatch({type: "get-all-exchanges-with-coins-success", payload: res?.data });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () => getAllExchangesWithTheirCoins(signal, retryCount + 1),
            "get-all-exchanges-with-coins-error",
            "user",
            "email",
            formatTelegramLog("all_exchanges_with_coins", data, url),
            0,
            currentPath,
        );
      });
  };

// "get-all-exchanges-with-coins-request"
// "get-all-exchanges-with-coins-success"
// "get-all-exchanges-with-coins-error"

// export const getPortfolioFast =
//   (user, email, exchange_id) => async (dispatch) => {
//     dispatch({ type: GET_EXCHANGE_PORTFOLIO_FAST_REQUEST });
//     await axios
//       .post(baseUrl, {
//         mode: "get_portfolio",
//         user,
//         email,
//         exchange_id,
//         usd_balance_calculation: "False",
//       })
//       .then((res) => {
//         dispatch({
//           type: GET_EXCHANGE_PORTFOLIO_FAST_SUCCESS,
//           payload: res?.data,
//         });
//       })
//       .catch((err) => {
//         const { STATUS_CODE, MESSAGE } = err?.response?.data;
//         if (STATUS_CODE === 454) {
//           dispatch(getExchangePortfolio(user, email, exchange_id));
//         } else {
//           dispatch({
//             type: GET_EXCHANGE_PORTFOLIO_FAST_ERROR,
//             payload: MESSAGE,
//           });
//           errorHandler(STATUS_CODE, MESSAGE);
//         }
//       });
//   };
